import { render, staticRenderFns } from "./not-found.view.vue?vue&type=template&id=814f1d94&scoped=true&"
import script from "./not-found.view.ts?vue&type=script&lang=ts&"
export * from "./not-found.view.ts?vue&type=script&lang=ts&"
import style0 from "./not-found.view.scss?vue&type=style&index=0&id=814f1d94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "814f1d94",
  null
  
)

export default component.exports